export enum ErrorCodes {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_NOT_FOUND_LOCKED_OUT = 'USER_NOT_FOUND_LOCKED_OUT',
  FROZEN_CREDIT_REPORT = 'FROZEN_CREDIT_REPORT',
  INCORRECT_ANSWERS = 'INCORRECT_ANSWERS',
  USER_LOCKED_OUT = 'USER_LOCKED_OUT',
}
